import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent {
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() small: boolean = false;
  @Output() inputValue = new EventEmitter<string>();

  onKey(event: any) {
    this.inputValue.emit(event.target.value);
  }
}
